import { Clear } from '@mui/icons-material';
import { FormControl, IconButton, InputLabel, MenuItem, Select } from '@mui/material';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import './Selector.css';

function Selector(props) {
  const {
    label,
    labelId,
    selected,
    setSelected,
    items,
    error,
    disabled,
    variant,
    className,
    labelClassName,
    inputClassName,
    resetIcon,
    resetValue,
    enableClear = false,
  } = props;

  function onStatusChange(event) {
    const value = event.target.value;
    if (selected !== value) {
      setSelected(value);
    }
  }

  return (
    <FormControl className={`selector-container ${className}`}>
      {labelId && label && (
        <InputLabel error={error} id={labelId} className={`selector-input-label ${labelClassName}`} variant={variant}>
          {label}
        </InputLabel>
      )}
      {resetIcon && selected !== resetValue && (
        <IconButton size="small" className="custom-selector-reset-button" onClick={() => setSelected(resetValue)}>
          {resetIcon}
        </IconButton>
      )}
      <Select
        variant={variant}
        labelId={labelId}
        value={selected}
        onChange={onStatusChange}
        disabled={disabled}
        className={inputClassName}
        endAdornment={
          enableClear ? (
            <IconButton sx={{ display: selected ? '' : 'none' }} onClick={() => setSelected(undefined)}>
              <Clear />
            </IconButton>
          ) : (
            ''
          )
        }
      >
        {items.map((item, index) => (
          <MenuItem value={item.value} key={index}>
            {item.icon && (
              <item.icon className={clsx('selector-item-icon', item.iconColor && `color-${item.iconColor}`)} />
            )}
            <span className="selector-item-label">{item.label}</span>
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}

Selector.propTypes = {
  labelId: PropTypes.string,
  label: PropTypes.string,
  selected: PropTypes.string,
  setSelected: PropTypes.func,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string,
      label: PropTypes.string,
      icon: PropTypes.oneOfType([PropTypes.elementType, PropTypes.func, PropTypes.element]),
      iconColor: PropTypes.string,
    }),
  ),
  error: PropTypes.bool,
  disabled: PropTypes.bool,
  variant: PropTypes.string,
  className: PropTypes.string,
  labelClassName: PropTypes.string,
  inputClassName: PropTypes.string,
};

Selector.defaultProps = {
  labelId: '',
  label: '',
  selected: '',
  setSelected: () => {},
  items: [],
  itemRender: undefined,
  resetIcon: undefined,
  resetValue: '',
  error: false,
  disabled: false,
  variant: 'outlined',
  className: '',
  labelClassName: '',
  inputClassName: '',
};

export { Selector };
